import { colors } from '@config/theme'
import { AffiliateLinkItem } from '@libs/types/AffiliateLinkItem.ts'
import { Box, Grid, Typography } from '@mui/material'
import { useAppSelector } from '@store/hooks.ts'
import mixpanel from 'mixpanel-browser'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const AffiliateGearCard = ({
  data,
  position,
  renderPage,
}: {
  data: AffiliateLinkItem
  position: number
  renderPage?: string
}) => {
  const selectedMetro = useAppSelector((state) => state.metro.selectedMetro)

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} width={'100%'}>
      <StyledCard
        to={data.affiliate_link}
        target="_blank"
        onClick={() => {
          mixpanel.track('Clicked Affiliate Link', {
            'Page title': renderPage === 'homepage' ? 'Homepage' : 'Camp Detail Page',
            Metro: selectedMetro ? selectedMetro.name : 'not set',
            'Metro ID': selectedMetro ? selectedMetro.id : 'not set',
            Position: position,
            'Affiliate Link URL': data.affiliate_link,
            'Affiliate Product Title': data.product_title,
            'Affiliate Product Description': data.product_descr,
            'Affiliate Product Image': data.product_img,
            'Affiliate Product Interests': data.interest_tags,
          })
        }}
        data-testid={`${renderPage}_affiliate_links_el_${position - 1}`}
      >
        <StyledImageWrapper>
          <StyledMainImage
            data-testid={`${renderPage}_affiliate_links_${position - 1}_prod_image`}
            src={data.product_img}
            alt={data.product_title}
            loading={'lazy'}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = '/src/assets/media/images/no-camp-image-fallback.jpg'
            }}
          />
        </StyledImageWrapper>
        <StyledCardContent>
          <StyledCardTitle data-testid={`${renderPage}_affiliate_links_${position - 1}_prod_title`}>
            {data.product_title}
          </StyledCardTitle>
          <StyledCardDescription data-testid={`${renderPage}_affiliate_links_${position - 1}_prod_description`}>
            {data.product_descr}
          </StyledCardDescription>
        </StyledCardContent>
      </StyledCard>
    </Grid>
  )
}

const StyledCard = styled(Link)`
  border-radius: 16px;
  padding: 16px;
  width: 100%;
  max-width: 412px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f2f4f7 !important;
`

const StyledCardContent = styled(Box)`
  padding: 1rem 0 !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.25rem;
`
const StyledCardTitle = styled(Typography)`
  color: ${colors.brandGray900};
  font-size: 1rem !important;
  line-height: 1.25rem !important;
  font-weight: 700 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

const StyledCardDescription = styled(Typography)`
  color: ${colors.brandGray};
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
  font-weight: 600 !important;
`

const StyledImageWrapper = styled(Box)`
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledMainImage = styled.img`
  object-fit: contain;
  width: 100%;
`
